<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>

    <v-card :loading="adhocLineItemsLoading">

      <v-card-title>Edit Line Items</v-card-title>

      <template v-if="!adhocLineItemsLoading">

        <v-card-text>
          <template v-for="(cat, cati) in lineItems">
            <p :key="cati" :class="(cati!==0)?'mt-5':''"><b>{{cat.name}}</b></p>

            <template v-for="(item, catj) in cat.items">
              <v-sheet :key="`list-${item.id}`" :elevation="(item.selected)?3:0" :class="(item.selected)?'pa-2 my-2':'mb-n5'" rounded>

                <v-checkbox v-model="item.selected" @click="autoQuantity(item)" @change="checkForHardware();" :disabled="item.stock<=10&&item.stock!==null">
                  <span slot="label" v-html="itemLabel(item)"></span>
                </v-checkbox>

                <template v-if="item.selected">
                  <v-row>

                    <v-col>
                      <v-text-field prefix="£" v-model="item.price" :disabled="!item.allow_custom_price" outlined dense hide-details label="Price" type="number" step=".01" @blur="$v.lineItems.$each[cati].items.$each[catj].$touch();" @input="$v.lineItems.$each[cati].items.$each[catj].$touch();"></v-text-field>
                    </v-col>

                    <v-col v-if="!item.allow_custom_price">
                      <v-text-field v-model.number="item.quantity" :disabled="item.allow_custom_price" outlined dense hide-details label="Quantity" type="number" @change="calcTotal(item)" @click="calcTotal(item)" min="1"></v-text-field>
                    </v-col>

                    <v-col v-if="!item.allow_custom_price">
                      <v-text-field prefix="£" v-model="item.total" disabled outlined dense hide-details label="Total"></v-text-field>
                    </v-col>

                  </v-row>

                </template>

                <p v-if="item.allow_custom_price && item.selected && $v.lineItems.$each[cati].items.$each[catj].price.$invalid" class="text-caption error--text mt-n2 ml-2">{{ lineItemErrors(cati, catj)[0] }}</p>
              </v-sheet>
            </template>

            <template v-for="group in cat.groups">
              <v-sheet :key="`list-${group.name}`" :elevation="(group.selected)?3:0" :class="(group.selected)?'pa-2 my-2':'mb-n5'" rounded>
                
                <v-checkbox v-model="group.selected" @change="resetGroupItems(group);checkForHardware();" :disabled="hardwareSelected">
                  <span slot="label" v-html="groupLabel(group)"></span>
                </v-checkbox>

                <template v-if="group.selected">

                  <v-row>
                    <v-col>
                      <v-select dense outlined hide-details :items="group.items" @change="updateGroupItems(group)" item-text="name" v-model="group.current" return-object label="Select Option"></v-select>
                    </v-col>
                  </v-row>

                  <template v-if="group.current.id!==undefined">
                    <v-row>

                      <v-col>
                        <v-text-field prefix="£" v-model="group.current.price" disabled outlined dense hide-details label="Price"></v-text-field>
                      </v-col>

                      <v-col>
                        <v-text-field v-model.number="group.current.quantity" outlined dense hide-details label="Quantity" type="number" @change="calcTotal(group.current)" @click="calcTotal(group.current)" min="1"></v-text-field>
                      </v-col>

                      <v-col>
                        <v-text-field prefix="£" v-model="group.current.total" disabled outlined dense hide-details label="Total"></v-text-field>
                      </v-col>

                    </v-row>
                  </template>
                </template>
              </v-sheet>
            </template>

          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>

          <v-btn text>Total - {{total}}</v-btn>

          <v-spacer></v-spacer>

          <v-btn color="primary" small @click="submit" :disabled="saveLoading" :loading="saveLoading">SAVE</v-btn>
          <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>

        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>

  import { mapGetters,mapMutations,mapActions,mapState } from 'vuex';
  import { validationMixin } from "vuelidate";
  import { requiredIf, between, decimal } from "vuelidate/lib/validators";

  const priceFormat = (value) => /^\d+(\.\d{1,2})?$/.test(value);

  export default {
    mixins: [validationMixin],

    props: ['dialogOpen','saveType'],

    validations: {
      lineItems: {
        $each: {
          items: {
            $each: {
              price: {
                required: requiredIf((vm) => vm.allow_custom_price && vm.selected),
                between: between(0, 500),
                priceFormat,
              }
            }
          }
        }
      }
    },

    data() {
      return {
        lineItems: [],
        saveLoading: false,
        p_kind: '',
      }
    },

    computed: {

      ...mapState('adhoc',['adhocLineItemsLoading']),
      ...mapState('products',['currentProduct']),
      ...mapGetters('adhoc',['getAdhocLineItems']),
      ...mapGetters('upfrontcosts',['getCurrentUpfrontCostIds']),

      total(){
        let total = 0;
        this.lineItems.forEach(cat => {
          cat.items.forEach(item => { if(item.selected){ total += (item.price*item.quantity); } });
          if(cat.hasGroups){
            Object.keys(cat.groups).forEach(k => {
              let group = cat.groups[k];
              if(group.current.id!==undefined){
                total += (group.current.price*group.current.quantity);
              }
            });
          }
        });
        return `£${total.toFixed(2)}`;
      },

      hardwareSelected(){
        let cats = this.lineItems;
        let isSelected = false;
        cats.forEach(cat => {
          let isHardware = ['hardware phones','headsets'].indexOf(cat.name.toLowerCase())!==-1;
          let items = cat.items;
          items.forEach(item => {
            if(isHardware&&item.selected){ isSelected = true; }
          });
        });
        return isSelected;
      },

      lineItemErrors() {
        return (cati, catj) => {
          const errors = [];
          if (!this.$v.lineItems.$each[cati].items.$each[catj].$dirty) return errors;
          !this.$v.lineItems.$each[cati].items.$each[catj].price.required && errors.push("Price is required");
          !this.$v.lineItems.$each[cati].items.$each[catj].price.priceFormat && errors.push("Price must use correct format eg £0.00");
          !this.$v.lineItems.$each[cati].items.$each[catj].price.between && errors.push("Price must be between £0 and £500");
          return errors;
        }
      },
    },

    watch: {

      async dialogOpen(val) {
        if(val){
          this.p_kind = this.currentProduct.product_kind.toLowerCase();

          if(this.getAdhocLineItems(this.saveType).length===0){
            await this.fetchAdhocLineItems(this.currentProduct.product_kind.toLowerCase());
            this.lineItems = this.getAdhocLineItems(this.saveType);
          }else{
            this.lineItems = this.getAdhocLineItems(this.saveType);
          }
          
          if(this.saveType==='upfront'){
            this.lineItems.forEach(cat => {
              if(cat.hasGroups){
                Object.keys(cat.groups).forEach(k => {
                  let group = cat.groups[k];
                  group.items.forEach(item => {
                    let ids = this.getCurrentUpfrontCostIds.map(e=>{return e.id;});
                    let index = ids.indexOf(item.id);
                    if(index!==-1){
                      item.selected = true;
                      group.selected = true;
                      item.quantity = this.getCurrentUpfrontCostIds[index].quantity;
                      group.current = item;
                      this.calcTotal(item);
                    }
                  });
                });
              }

              cat.items = cat.items.reduce((acc, item) => {
                let ids = this.getCurrentUpfrontCostIds.map(e=>{return e.id;});
                let index = ids.indexOf(item.id);
                let isCurrent = index !== -1;
                if(item.available || !item.available && isCurrent){
                  if(isCurrent){
                    item.selected = true;
                    item.quantity = this.getCurrentUpfrontCostIds[index].quantity;
                    this.calcTotal(item);
                  }
                  acc.push(item);
                }
                return acc;
              }, []);
            });
          }
        }
      }
    },

    methods: {

      ...mapActions('adhoc',['fetchAdhocLineItems']),
      ...mapActions('upfrontcosts',['updateUpfrontCostsById']),
      ...mapMutations('adhoc',['setCurrentAdhocInvoiceLineItems']),

      checkForHardware(){
        let cats = this.lineItems;
        let selectDelivery = false;
        let deliverySelected = false;
        cats.forEach(cat => {
          let isHardware = ['hardware phones','headsets'].indexOf(cat.name.toLowerCase())!==-1;
          let items = cat.items;
          items.forEach(item => {
            if(isHardware&&item.selected){ selectDelivery = true; }
          });
          if(cat.hasGroups){
            let groups = cat.groups;
            Object.keys(groups).forEach(key => {
              let group = groups[key];
              if(isHardware&&group.selected){ selectDelivery = true; }
              if(key==='phone_delivery'){
                if(group.selected&&group.current.id!==undefined){ deliverySelected = true; }
              }
            });
          }
        });
        if(!deliverySelected&&selectDelivery){
          cats.forEach(cat => {
            if(cat.hasGroups){
              let groups = cat.groups;
              Object.keys(groups).forEach(key => {
                let group = groups[key];
                if(key==='phone_delivery'){
                  group.selected = true;
                  group.items.forEach(item => {
                    if(item.id===140||item.id===144){
                      group.current = item;
                      item.selected = true;
                      item.quantity = 1;
                    }
                  });
                }
              });
            }
          });
        }
      },

      itemLabel(item){
        let stock = item.stock;
        if(item.selected||stock===null){
          return `<b>${item.name}</b><br><small class="body--text">£${item.price}</small>`;
        }else{
          if(stock===0){
            return `<b>${item.name}</b><br><small class="error--text">Out of stock</small>`;
          }else if(stock<=10){
            return `<b>${item.name}</b><br><small class="error--text">£${item.price} (This item is too low stock to order)</small>`;
          }else if(stock<=25){
            return `<b>${item.name}</b><br><small class="warning--text">£${item.price} (${item.stock} Low stock)</small>`;
          }else{
            return `<b>${item.name}</b><br><small class="body--text">£${item.price} (${item.stock} In stock)</small>`;
          }
        }
      },

      groupLabel(group){
        let items = group.items;
        let prices = [];
        items.forEach(item => {
          prices.push(parseFloat(item.price));
        });
        let min = Math.min(...prices).toFixed(2);
        let max = Math.max(...prices).toFixed(2);
        return `<b>${group.name}</b><br><small class="body--text">£${min} - £${max}</small>`;
      },

      resetItems(){
        this.lineItems.forEach(cat => {
          cat.items.forEach(item => {
            item.selected = false;
          });
        });
      },

      resetGroupItems(group){
        group.items.forEach(item => {
          item.quantity = 0;
          item.total = 0;
        });
        group.current = {};
      },

      updateGroupItems(group){
        group.items.forEach(item => {
          item.quantity = 0;
          item.total = 0;
        });
        group.current.quantity = 1;
        this.calcTotal(group.current);
      },

      autoQuantity(item){
        item.quantity = (item.selected)?1:0;
        this.calcTotal(item);
      },

      calcTotal(item){
        item.total = (item.price*item.quantity).toFixed(2);
      },

      async submit(){
        this.$v.$touch();
        if(this.$v.$invalid) return;
        this.saveLoading = true;
        let items = [];
        switch(this.saveType){
          case 'adhoc':
            this.lineItems.forEach(cat => {
              cat.items.forEach(item => {
                if(item.selected){
                  item.cat = cat.name;
                  items.push(item);
                }
              });
              if(cat.hasGroups){
                Object.keys(cat.groups).forEach(k => {
                  let group = cat.groups[k];
                  let item = group.current;
                  if(item.id!==undefined){
                    item.cat = cat.name;
                    items.push(item);
                  }
                });
              }
            });
            this.setCurrentAdhocInvoiceLineItems(items);
            this.saveLoading = false;
            this.closeDialog();
            break;
          case 'upfront':
            this.lineItems.forEach(cat => {
              cat.items.forEach(item => {
                if(item.selected){
                  items.push({charge_id:item.id,quantity:item.quantity});
                }
              });
              if(cat.hasGroups){
                Object.keys(cat.groups).forEach(k => {
                  let group = cat.groups[k];
                  let item = group.current;
                  if(item.id!==undefined){
                    items.push({charge_id:item.id,quantity:item.quantity});
                  }
                });
              }
            });
            try{
              await this.updateUpfrontCostsById({pid:this.currentProduct.id,data:items});
              this.saveLoading = false;
              this.closeDialog();
            }catch(err){
              this.saveLoading = false;
            }
            break;
        }
      },

      closeDialog(){
        this.resetItems();
        this.$emit('close-dialog');
      },
      
    },
  }
</script>

<style lang="scss" scoped>
</style>
